/**
 * Runs task in callback. For render phase use `useAsyncRun`
 * @param task
 * @param args
 */
export const runAsyncTask = (task, ...args) =>
  task.start(...args).catch(() => {});
